export const getEnterpriseWelcomeMessage = (state) =>
  state.virtualOperator.welcomeMessage;
export const isEnterpriseWelcomeMessageSaveLoaded = (state) =>
  state.virtualOperator.saveEnterpriseWelcomeMessageLoaded;
export const isEnterpriseWelcomeMessageSaveError = (state) =>
  state.virtualOperator.saveEnterpriseWelcomeMessageError;
export const getEnterpriseFestivities = (state) =>
  state.virtualOperator.enterpriseFestivities;
export const getEnterpriseFestivitiesMessage = (state) =>
  state.virtualOperator.enterpriseFestivitiesMessage;
export const getEnterpriseOpeningTable = (state) =>
  state.virtualOperator.openingTable;
export const getEnterpriseOpeningMessage = (state) =>
  state.virtualOperator.openingMessage;
export const isEnterpriseInfoLoaded = (state) =>
  state.virtualOperator.enterpriseInfoLoaded;
export const isEnterpriseInfoError = (state) =>
  state.virtualOperator.enterpriseInfoError;
export const getEnterpriseInfo = (state) =>
  state.virtualOperator.enterpriseInfo;
export const isSaveFestivitiesLoaded = (state) =>
  state.virtualOperator.saveFestivitiesLoaded;
export const isSaveFestivitiesError = (state) =>
  state.virtualOperator.saveFestivitiesError;
export const isSaveEnterpriseInfoLoaded = (state) =>
  state.virtualOperator.saveEnterpriseInfoLoaded;
export const isSaveEnterpriseInfoError = (state) =>
  state.virtualOperator.saveEnterpriseInfoError;
export const isSaveOpeningLoaded = (state) =>
  state.virtualOperator.saveOpeningLoaded;
export const isSaveOpeningError = (state) =>
  state.virtualOperator.saveOpeningError;
export const virtualOperatorUsersLoaded = (state) =>
  state.virtualOperator.fetchUsersLoaded;
export const virtualOperatorUsersError = (state) =>
  state.virtualOperator.fetchUsersError;
export const getVirtualOperatorUsers = (state) => state.virtualOperator.users;
export const getVirtualOperatorUsersTotal = (state) =>
  state.virtualOperator.totalUsers;
export const isSaveUserLoaded = (state) => state.virtualOperator.saveUserLoaded;
export const isSaveUserError = (state) => state.virtualOperator.saveUserError;
export const isSaveOfficeLoaded = (state) =>
  state.virtualOperator.saveOfficeLoaded;
export const isSaveOfficeError = (state) =>
  state.virtualOperator.saveOfficeError;
export const virtualOperatorMessagesLoaded = (state) =>
  state.virtualOperator.fetchMessagesLoaded;
export const virtualOperatorMessagesError = (state) =>
  state.virtualOperator.fetchMessagesError;
export const getVirtualOperatorMessages = (state) =>
  state.virtualOperator.messages;
export const getVirtualOperatorMessagesTotal = (state) =>
  state.virtualOperator.totalMessages;
export const isSaveMessageLoaded = (state) =>
  state.virtualOperator.saveMessageLoaded;
export const isSaveMessageError = (state) =>
  state.virtualOperator.saveMessageError;
export const isDeleteMessageLoaded = (state) =>
  state.virtualOperator.deleteMessageLoaded;
export const isDeleteMessageError = (state) =>
  state.virtualOperator.deleteMessageError;
export const isFetchSettingsLoaded = (state) =>
  state.virtualOperator.fetchSettingsLoaded;
export const isFetchSettingsError = (state) =>
  state.virtualOperator.fetchSettingsError;
export const getVirtualOperatorSettingsFestivities = (state) =>
  state.virtualOperator.settings.festivities;
export const getVirtualOperatorSettingsClosing = (state) =>
  state.virtualOperator.settings.closing;
export const isSaveFestivitySettingsLoaded = (state) =>
  state.virtualOperator.saveSettingsFestivitiesLoaded;
export const isSaveFestivitySettingsError = (state) =>
  state.virtualOperator.saveSettingsFestivitiesError;
export const isSaveFestivitySettingsSuccess = (state) =>
  state.virtualOperator.saveSettingsFestivitiesSuccess;
export const isSaveClosingSettingsLoaded = (state) =>
  state.virtualOperator.saveSettingsClosingLoaded;
export const isSaveClosingSettingsError = (state) =>
  state.virtualOperator.saveSettingsClosingError;
export const isSaveClosingSettingsSuccess = (state) =>
  state.virtualOperator.saveSettingsClosingSuccess;
export const getVirtualOperatorStatistics = (state) =>
  state.virtualOperator.statistics;
export const getVirtualOperatorStatisticsTotal = (state) =>
  state.virtualOperator.totalStatistics;
export const isVirtualOperatorStatisticsLoaded = (state) =>
  state.virtualOperator.fetchStatisticsLoaded;
export const isVirtualOperatorStatisticsError = (state) =>
  state.virtualOperator.fetchStatisticsError;
export const getVirtualOperatorDetails = (state) =>
  state.virtualOperator.details;
export const isVirtualOperatorChatDetailsLoaded = (state) =>
  state.virtualOperator.fetchChatDetailsLoaded;
export const isVirtualOperatorChatDetailsError = (state) =>
  state.virtualOperator.fetchChatDetailsError;
export const getVirtualOperatorStatisticsFilter = (state) =>
  state.virtualOperator.statisticsFilter;
export const getVirtualOperatorMonitoring = (state) =>
  state.virtualOperator.monitoring;
export const isVirtualOperatorMonitoringLoaded = (state) =>
  state.virtualOperator.fetchMonitoringLoaded;
export const isVirtualOperatorMonitoringError = (state) =>
  state.virtualOperator.fetchMonitoringError;
export const getVirtualOperatorCosts = (state) =>
  state.virtualOperator.costs;
export const isVirtualOperatorCostsLoaded = (state) =>
  state.virtualOperator.fetchCostsLoaded;
export const isVirtualOperatorCostsError = (state) =>
  state.virtualOperator.fetchCostsError;
export const getVirtualOperatorAmbrogioCosts = (state) =>
  state.virtualOperator.ambrogioCosts;
export const getVirtualOperatorAmbrogioCostsTotal = (state) =>
  state.virtualOperator.totalAmbrogioCosts;
export const getVirtualOperatorAmbrogioExtraCostsTotal = (state) =>
  state.virtualOperator.totalAmbrogioExtraCosts;
export const isVirtualOperatorAmbrogioCostsLoaded = (state) =>
  state.virtualOperator.fetchAmbrogioCostsLoaded;
export const isVirtualOperatorAmbrogioCostsError = (state) =>
  state.virtualOperator.fetchAmbrogioCostsError;
export const getVirtualOperatorAmbrogioPbxs = (state) =>
  state.virtualOperator.ambrogioPbxs || [];
export const isVirtualOperatorAmbrogioPbxsLoaded = (state) =>
  state.virtualOperator.fetchAmbrogioPbxsLoaded;
export const isVirtualOperatorAmbrogioPbxsError = (state) =>
  state.virtualOperator.fetchAmbrogioPbxsError;
export const isSaveNoCreditRuleLoaded = (state) =>
  state.virtualOperator.saveNoCreditRuleLoaded;
export const isSaveNoCreditRuleError = (state) =>
  state.virtualOperator.saveNoCreditRuleError;
export const isSaveNoCreditRuleSuccess = (state) =>
  state.virtualOperator.saveNoCreditRuleSuccess;
export const isSaveTicketSettingsLoaded = (state) =>
  state.virtualOperator.saveTicketSettingsLoaded;
export const isSaveTicketSettingsError = (state) =>
  state.virtualOperator.saveTicketSettingsError;
export const isSaveTicketSettingsSuccess = (state) =>
  state.virtualOperator.saveTicketSettingsSuccess;